import ArtForAirTiff from './ArtForAirTiff';
export default ArtForAirTiff;
